import { Component, OnInit } from '@angular/core'
import { Location } from '@angular/common'

@Component({
  standalone: false,
  selector: 'app-not-found',
  templateUrl: './not-found.component.html'
})
export class NotFoundComponent implements OnInit {

  private shouldSendBack = false
  public backLink = 'https://sportsengine.com'
  public backText = 'Back'

  constructor(private location: Location) { }

  public ngOnInit() {
    this.shouldSendBack = this.hasHistory()
    this.backText = this.setBackText(this.shouldSendBack)
  }

  private setBackText(shouldSendBack: boolean): string {
    if (shouldSendBack) {
      return 'Back'
    } else {
      return 'Back to SportsEngine.com'
    }
  }

  public goBack() {
    if (this.shouldSendBack) {
      this.location.back()
    } else {
      window.location.href = 'https://sportsengine.com'
    }
  }

  private hasHistory(): boolean {
    return window.history.length > 1
  }

}
